const style = (theme) => {
  const output = {
    root: {
    },
    title: {
      alignItems: 'flex-start',
      '& h3': {
        fontSize: 24,
        textTransform: 'uppercase',
        padding: '20px 30px',
        backgroundColor: theme.colors[2],
        color: theme.colors[1],
        display: 'inline-block',
        width: 'auto',
      },
    },
    table: {
      '& > li': {
        listStyleType: 'none',
        backgroundColor: theme.colors[6],
        transition: `all 0.1s ${theme.easings['power3.out']}`,
        '&:hover': {
          backgroundColor: theme.getRgba(theme.colors[0], 0.3),
        },
        '&:nth-child(even)': {
          backgroundColor: theme.colors[5],
          '&:hover': {
            backgroundColor: theme.getRgba(theme.colors[0], 0.3),
          },
        },
      },
    },
    item: {
      textTransform: 'uppercase',
      fontSize: 16,
      '& a': {
        display: 'flex',
        justifyContent: 'space-between',
        color: theme.colors[2],
      },
    },
    label: {
      padding: '14px 30px',
      flex: 1,
    },
    value: {
      width: '30%',
      padding: '14px 30px',
      textTransform: 'lowercase',
      textDecoration: 'underline',
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: 12,
        height: 12,
        marginRight: 15,
        transform: 'rotate(-90deg)',
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    title: {
      fontSize: 18,
      padding: '20px 15px',
    },
    item: {
      fontSize: 14,
      marginBottom: '0 !important',
    },
    label: {
      padding: '14px 15px',
    },
    value: {
      width: '40%',
      padding: '14px 15px',
    },
  }

  return output
}

export default style
